import store2 from 'store2';

export function addMonitor(
  evtTarget,
  evtName,
  callback,
  options,
) {
  if ('attachEvent' in evtTarget) {
      return evtTarget.attachEvent(`on${evtName}`, callback);
  }
  return evtTarget.addEventListener(evtName, callback, options);
}

export function removeMonitor(
  evtTarget,
  evtName,
  callback,
  options,
) {
  if ('attachEvent' in evtTarget) {
      return evtTarget.detachEvent(`on${evtName}`, callback);
  }
  return evtTarget.removeEventListener(evtName, callback, options);
}

export function setRouteTrack(routeName, routePath) {
  const routeTrackList = store2.session('ts.log.route.track') || []
  routeTrackList.push({
    page_name: routeName,
    page_path: routePath,
  })
  store2.session('ts.log.route.track', routeTrackList)
}

export function getFromPath() {
  const routeTrackList = store2.session('ts.log.route.track') || [];
  const from_path = routeTrackList.map((item) => item.page_name)
  return from_path.join('.')
}

export function getCurrentRoute() {
  const routeTrackList = store2.session('ts.log.route.track') || [];
  const curRoute = routeTrackList[routeTrackList.length - 1];
  return curRoute || {}
}
